// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mockApi: false,
  oAuth: {
    /*
    * When using Azure AD for OAuth:
    *
    * issuer: 'https://login.microsoftonline.com/<TENANT_ID>/v2.0'
    * Replace <TENANT_ID> with Tenant ID from Azure portal
    *
    * clientId: '<CLIENT_ID>'
    * Replace <CLIENT_ID> with the Client ID of the SPA registered under App registrations in Azure portal
    *
    * The following document may act as a good reference in Registering an app with Azure AD:
    * https://learn.microsoft.com/en-us/azure/active-directory/develop/quickstart-register-app
    *
    * tokenEndpoint:
    * You can get the tokenEndpoint from 'https://login.microsoftonline.com/<TENANT_ID>/oauth2/v2.0/token'
    * Replace <TENANT_ID> with Tenant ID from Azure portal
    *
    */
    issuer: 'https://stg12.canadapost.ca/mga/sps/oauth/oauth20/metadata/ISAMOP',
    clientId: 'profile2',
    redirectUri: window.location.origin + '/index.html',
    timeoutFactor: 0.25,
    sessionChecksEnabled: true,
    showDebugInformation: true,
    tokenEndpoint: 'https://stg12.canadapost.ca/isam/sps/oauth/oauth20/token',
    strictDiscoveryDocumentValidation: false,
    silentRefreshTimeout: 1000,
    resourceServer: '/rs/location'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
